export default __webpack_public_path__ + "static/media/remote-down.a7bc194f.png";